import { PureComponent } from 'react';

import { loadScript } from '../../utils/loader';

export default class Tawk extends PureComponent {
  componentDidMount() {
    this.init();
    this.load();
  }

  init() {
    if (!window) {
      return;
    }

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
  }

  load() {
    const url = 'https://embed.tawk.to/5ac801dc4b401e45400e6bf0/default';
    const attributes = { crossorigin: '*' };
    loadScript('tawk', url, attributes);
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/widgets/Tawk/index.js